import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { sizePropTypes } from '@ecp/common/src/style/propTypes';
import { overrideProperties } from '@ecp/common/src/style/utils';
import SwiperHeroBannerUnstyled from '@ecp/common/src/components/unstyled/swiper/SwiperHeroBannerUnstyled';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/grid';
import { SwiperHeroVerticalCotroller } from '@ecp/common/src/components/swiper/component/SwiperController';

export const StyledRoundedWrapper = styled.div`
  position: relative;
  ${overrideProperties(sizePropTypes, {})};
  background-color: ${({ backgroundColor }) => backgroundColor ?? 'none'};

  .swiper {
    border-radius: ${({ round }) => (round ? '20px' : 0)};
    ${({ radius }) => radius && { 'border-radius': radius }}
    height: 100%;
    width: 100%;

    &-wrapper {
      transform-style: preserve-3d;
    }

    &-slide {
      display: flex;
      & > div {
        display: flex;
      }
    }
  }

  .swiper-3d .swiper-slide-shadow {
    background: none;
  }
`;

export const SwiperHeroVertical = React.forwardRef(({ padding, ...props }, ref) => {
  const additionalProps = {
    rootProps: { style: { padding } },
    wrapperComponent: StyledRoundedWrapper,
    controllerComponent: SwiperHeroVerticalCotroller,
  };

  return <SwiperHeroBannerUnstyled ref={ref} wrapperComponent={StyledRoundedWrapper} {...additionalProps} {...props} />;
});

SwiperHeroVertical.propTypes = {
  itemList: PropTypes.array,
  itemProps: PropTypes.object,
  pagingProps: PropTypes.object,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  carouselProps: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
  controlProps: PropTypes.object,
  round: PropTypes.bool,
  padding: PropTypes.string,
  backgroundColor: PropTypes.string,
};

SwiperHeroVertical.defaultProps = {
  itemList: [],
  itemProps: {},
};

SwiperHeroVertical.displayName = 'SwiperHeroVertical';
export default SwiperHeroVertical;
